/**
 * I COLORI DELLE PROP FIRM: una tavolozza fissa di dieci tinte, per CHIAVE.
 *
 * Servono solo a distinguere a colpo d'occhio una prop dall'altra (Operazione,
 * Prop firm). In database sta la chiave (`PropFirm.color`), mai l'esadecimale:
 * la tinta si puo' ritoccare qui senza toccare nessuna riga.
 *
 * Le tinte stanno lontane dal verde (`--gain`, ~150°) e dal rosso (`--loss`,
 * ~0°) del P&L, dall'ambra/oro del broker e del marchio (~38°) e dal blu dei
 * conti prop (`--prop`, ~223°): per questo manca ogni blu «puro». Restano
 * acqua (teal, cyan), oliva e rame, la zona viola-rosa (orchid, magenta, pink,
 * rose) e due grigi, freddo e caldo. Sono colori PIENI, di media luminosita':
 * la resa tenue la decide chi li usa (`propColorRgba`), con l'opacita'.
 */
export const PROP_COLORS = {
    teal: "#3fb8af",
    cyan: "#3ab9d4",
    olive: "#a8b46a",
    copper: "#c9876a",
    orchid: "#b873d9",
    magenta: "#d062c4",
    pink: "#ea7ab5",
    rose: "#cf8fa3",
    slate: "#8394a8",
    stone: "#a39a8e",
};
/** L'ordine della tavolozza: e' anche l'ordine di assegnazione del predefinito. */
export const PROP_COLOR_KEYS = Object.keys(PROP_COLORS);
export function isPropColorKey(v) {
    return typeof v === "string" && Object.prototype.hasOwnProperty.call(PROP_COLORS, v);
}
/**
 * La chiave meno usata fra quelle in uso, a parita' la prima in ordine.
 * Chiavi fuori tavolozza e null non contano: «non lo so» non e' una tinta usata.
 */
export function leastUsedPropColor(used) {
    const uses = new Map(PROP_COLOR_KEYS.map((k) => [k, 0]));
    for (const u of used)
        if (isPropColorKey(u))
            uses.set(u, uses.get(u) + 1);
    let best = PROP_COLOR_KEYS[0];
    for (const k of PROP_COLOR_KEYS)
        if (uses.get(k) < uses.get(best))
            best = k;
    return best;
}
/** La tinta come `rgba(...)`: l'opacita' e' di chi la usa, il colore pieno non si mostra mai da solo. */
export function propColorRgba(key, alpha) {
    const h = PROP_COLORS[key].slice(1);
    const n = (i) => parseInt(h.slice(i, i + 2), 16);
    return `rgba(${n(0)}, ${n(2)}, ${n(4)}, ${alpha})`;
}
//# sourceMappingURL=prop-colors.js.map